import { Component, OnInit } from '@angular/core';
import { PageEvent } from '@angular/material/paginator';
import { MatDialog } from '@angular/material/dialog';

// Models
import { MetaData } from 'src/app/platform/models/utils';
import { User } from 'src/app/modules/account/models/user';
import { InvoicesData } from 'src/app/modules/invoices/models/invoices';
import { ScreenLoaderData } from 'src/app/platform/components/ui-screen-loader/ui-screen-loader.model';
import { PaymentGenerateData } from 'src/app/modules/payments/models/payments';

// Services
import { UserService } from 'src/app/modules/account/user.service';
import { UiService } from 'src/app/platform/services/ui.service';
import { InvoicesService } from 'src/app/modules/invoices/invoices.service';
import { PaymentsService } from 'src/app/modules/payments/payments.service';
import { ListExportService } from 'src/app/platform/services/platform.service';

// Components
import { UiDialogComponent } from 'src/app/platform/components/ui-dialog/ui-dialog.component';
import { PayModalComponent } from 'src/app/modules/payments/components/pay-modal/pay-modal.component';
import { InvoicesEmailSendComponent } from 'src/app/modules/invoices/views/invoices-email-send/invoices-email-send.component';


@Component({
  selector: 'app-invoices',
  templateUrl: './invoices.component.html',
  styleUrls: ['./invoices.component.scss']
})
export class InvoicesComponent implements OnInit {
  public user: User = new User();
  public filters: any = {
    type: '',
    status: '',
    date: { start: '', end: ''},
    dateExpiration: { start: '', end: ''}
  };
  public filterInvoiceTypes: MetaData[] = [];
  public filterInvoiceStatus: MetaData[] = [];
  public invoices: InvoicesData[] = [];
  public invoicesTotal = 0;
  public invoicesPage = 1;
  public invoicesPageSize = 10;
  public invoicesUpdating = false;
  public invoicesInitStatus = false;
  public invoicesSelected: Array<boolean> = [];
  public invoicesSelectedAmount = '';
  public isPaymentStatus = false;
  public cancelUnsuscribe = false;
  public errors = {
    load: new ScreenLoaderData('Cargando facturas', 'Estamos buscando todas las facturas emitidas.', 'receipt', true),
    empty: new ScreenLoaderData('No existen facturas en tu cuenta', 'Aún no dispones de ninguna factura. Cuando exista alguna podrás verla aquí.', 'help_outline'),
    error: new ScreenLoaderData('Ocurrió un error al intentar cargar las facturas', 'No pudimos obtener tus facturas, estamos trabajando para solucionar este problema. Por favor intenta revisar nuevamente mas tarde.', 'highlight_off'),
  };

  constructor(
    private uiDialog: MatDialog,
    private uiService: UiService,
    private userService: UserService,
    private invoicesService: InvoicesService,
    private paymentsService: PaymentsService,
    private listExportService: ListExportService,
  ) {
    this.userService.currentUser.subscribe((user) => {
      this.user = user;

      this.isPaymentStatus = (user.isPaymentStatus() /*&& (user.status === 'BajaMoroso' || user.status === 'BajaPendiente')*/);
    });
  }

  ngOnInit(): void {
    this.uiService.screenLoaderSet(this.errors.load);

    this.invoicesLoad(this.invoicesPage, this.invoicesPageSize).then((success) => {
      if (success.registersTotal > 0) {
        this.invoicesInitStatus = true;
        this.invoices = success.registers;
        this.invoicesTotal = success.registersTotal;
        this.invoicesPage = success.page;
      } else {
        this.uiService.screenLoaderSet(this.errors.empty);
      }
    }).catch((error) => {
      this.uiService.screenLoaderSet(this.errors.error);
    });

    this.invoicesService.invoicesTypesGet().then((success) => {
      this.filterInvoiceTypes = success.result;
    }).catch((error) => {
      this.filterInvoiceTypes = [new MetaData(0, 'Filtro no disponible')];
    });

    this.invoicesService.invoicesStatusGet().then((success) => {
      this.filterInvoiceStatus = success.result;
    }).catch((error) => {
      this.filterInvoiceStatus = [new MetaData(0, 'Filtro no disponible')];
    });
  }

  private invoicesLoad(page: number | null = null, limit: number | null = null, filters: any | null = null): Promise<any> {
    return new Promise((resolve, reject) => {
      this.invoicesService.invoicesGet(page, limit, filters).then((success) => {
        resolve(success.result);
      }).catch(() => {
        reject(false);
      });
    });
  }

  private invoicesChange(): void {
    this.invoicesUpdating = true;

    this.invoicesLoad(this.invoicesPage, this.invoicesPageSize, this.filters).then((success) => {
      this.invoicesUpdating = false;

      if (success.registersTotal > 0) {
        this.invoices = success.registers;
        this.invoicesTotal = success.registersTotal;
        this.invoicesPage = success.page;
      } else {
        this.invoices = [];
      }
    }).catch((error) => {
      this.invoicesUpdating = false;
      this.invoices = [];
      this.uiService.showSnackBar(this.errors.error.message);
    });
  }

  onPaginationChange(event: PageEvent): void {
    this.invoicesPage = event.pageIndex + 1;
    this.invoicesPageSize = event.pageSize;

    this.invoicesChange();
  }

  onFilterSelect(filter: string, value?: any): void {
    if (typeof this.filters[filter] !== 'undefined') {
      let update = true;

      if (filter === 'date' || filter === 'dateExpiration') {
        if (this.filters[filter].end === '' || this.filters[filter].end === null) {
          update = false;
        }

        if (value === '') {
          this.filters[filter] = {start: '', end: ''};
          update = true;
        }
      } else {
        this.filters[filter] = value;
      }

      if (update) {
        this.invoicesPage = 1;

        this.invoicesChange();
      }
    }
  }

  filtersData(filter: string, value: any): string {
    const filters: any = {
      type: {
        Factura: 'Factura',
        Credito: 'Nota de crédito',
        Debito: 'Nota de débito',
      },
      status: {
        Paga: 'Paga',
        Impaga: 'Impaga',
        Parcial: 'Parcial',
        Pendiente: 'Pendiente',
      }
    };

    if (typeof filters[filter] !== 'undefined') {
      if (typeof filters[filter][value] !== 'undefined') {
        return filters[filter][value];
      }
    }

    return '';
  }

  onDownload(invoice: InvoicesData): void {
    this.uiDialog.open(UiDialogComponent, {
      width: '350px',
      data: {
        title: 'Descargar factura ' + invoice.receipt,
        message: '¿Desea descargar la factura?',
        buttonCancelText: 'Cancelar',
        buttonConfirmText: 'Descargar',
        action: () => {
          this.uiService.showSpinner(true);

          this.invoicesService.pdfGet(invoice.id, invoice.type).then((success) => {
            this.uiService.showSpinner(false);
            window.open(success.result.url, '_blank');
          }).catch((error) => {
            this.uiService.showSpinner(false);
            this.uiService.dialogShow('Ups!', 'No es posible generar el PDF de la factura en este momento. Estamos trabajando para solucionar el inconveniente.', 'alert');
          });
        }
      }
    });
  }

  onDownloadPhonelist(invoice: InvoicesData): void {
    this.uiDialog.open(UiDialogComponent, {
      width: '350px',
      data: {
        title: 'Descargar listado de llamadas',
        message: 'A continuación se descargará el listado de llamadas realizadas',
        buttonCancelText: 'Cancelar',
        buttonConfirmText: 'Descargar',
        action: () => {
          window.open(invoice.pdfURL, '_blank');
        }
      }
    });
  }

  onEmailSend(invoice: InvoicesData): void {
    this.uiDialog.open(InvoicesEmailSendComponent, {
      width: '350px',
      data: {
        invoice
      }
    });
  }

  onPaymentAll(): void {
    this.uiDialog.open(PayModalComponent, {
      width: '400px'
    });
  }

  onPay(invoice?: InvoicesData): void {
    const receipts: Array<PaymentGenerateData> = [];

    if (typeof invoice !== 'undefined' && invoice instanceof InvoicesData) {
      if (invoice.status === 'Impaga') {
        receipts.push(new PaymentGenerateData(invoice.id, invoice.type, invoice.balance));
      }
    } else {
      this.invoices.forEach((invoice, index) => {
        if (typeof this.invoicesSelected[invoice.id] !== 'undefined' && this.invoicesSelected[invoice.id] === true){
          if (invoice.status === 'Impaga') {
            receipts.push(new PaymentGenerateData(invoice.id, invoice.type, invoice.balance));
          }
        }
      });
    }

    if (receipts.length > 0) {
      let amount = 0;

      receipts.forEach((invoice, index) => {
        amount = amount + invoice.importe;
      });

      this.uiDialog.open(PayModalComponent, {
        width: '400px',
        data: {
          amount,
          receipts
        }
      });
    }
  }

  onInvoicesSelected(): void {
    let amount = 0;

    this.invoices.forEach((invoice, index) => {
      if (typeof this.invoicesSelected[invoice.id] !== 'undefined' && this.invoicesSelected[invoice.id] === true){
        amount = amount + invoice.balance;
      }
    });

    this.invoicesSelectedAmount = (amount > 0) ? (amount).toFixed(2) : '';
  }

  onExport(type: string): void {
    this.uiService.showSpinner(true);

    this.invoicesLoad(1, null, this.filters).then((success) => {
      if (success.registersTotal > 0) {
        const items: any = [];

        success.registers.forEach((item: any) => {
          items.push({
            tipo: item.type,
            estado: item.status,
            comprobante: item.receipt,
            total: item.total,
            saldo: item.balance,
            periodo: item.periode,
            fechaEmision: item.date,
            fechaVencimiento: item.dateExpiration
          });
        });

        if (items.length > 0) {
          const structure = [
            {header: 'Tipo', body : 'tipo'},
            {header: 'Estado', body : 'estado'},
            {header: 'Comprobante', body : 'comprobante'},
            {header: 'Total', body : 'total'},
            {header: 'Saldo', body : 'saldo'},
            {header: 'Periodo', body : 'periodo'},
            {header: 'Fecha de emisión', body : 'fechaEmision'},
            {header: 'Fecha de vencimiento', body : 'fechaVencimiento'}
          ];

          this.listExportService.downloadFile(type, 'Listado de facturas', structure, items).then((response) => {
            this.uiService.showSpinner(false);
          });
        }
      } else {
        this.uiService.showSpinner(false);
        this.uiService.showSnackBar('No existen registros para generar la exportación');
      }
    }).catch((error) => {
      this.uiService.showSpinner(false);
      this.uiService.dialogShow('Ups!', 'No es posible generar la exportación en este momento. Estamos trabajando para solucionar el inconveniente.', 'alert');
    });
  }
}
